import { types } from 'mobx-state-tree';

export const TaxonomyCategoriesModel = types.model('TaxonomyCategoriesModel', {
    title: types.maybeNull(types.string),
    count: types.number,
    path: types.maybeNull(types.string),
    checked: false,
    children: types.array(types.late(() => TaxonomyCategoriesModel))
});
